import {styled} from "@mui/material";

export const PaginationContainer = styled('div')(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    height: '3rem',
    justifyContent: 'center',
    alignContent: 'center',
    width: '100%',
}));

